import { MenuItem, useMediaQuery, useTheme } from "@mui/material";
import React, { MouseEvent, PropsWithChildren } from "react";
import { FormattedMessage } from "react-intl";
import { matchPath, useLocation } from "react-router";
import { NavLink as RouterNavLink } from "react-router-dom";

import { ConnectButton, useLogout } from "@dzambalaorg/provider-wagmi";

export const SectionsMenu = (
  props: PropsWithChildren<{
    handleMenuClose: () => void;
  }>,
) => {
  const { handleMenuClose } = props;

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.down("md"));

  const location = useLocation();
  const { logout } = useLogout();

  const logoutHandler = async (e: MouseEvent): Promise<void> => {
    e.preventDefault();
    await logout();
    handleMenuClose();
  };

  return (
    <React.Fragment>
      <MenuItem
        onClick={handleMenuClose}
        component={RouterNavLink}
        to="/dashboard"
        color="inherit"
        selected={!!matchPath(location.pathname, "/dashboard")}
      >
        <FormattedMessage id="components.header.menu.dashboard" />
      </MenuItem>
      <MenuItem
        onClick={handleMenuClose}
        color="inherit"
        component={RouterNavLink}
        to="/profile"
        selected={!!matchPath(location.pathname, "/profile")}
      >
        <FormattedMessage id="components.header.menu.profile" />
      </MenuItem>
      {isMd && <ConnectButton />}
      <MenuItem onClick={logoutHandler}>
        <FormattedMessage id="components.header.menu.logout" />
      </MenuItem>
    </React.Fragment>
  );
};
